let prefix = `consulta`;

export const FIND_MARCACAO = `${prefix}/getMarcacao`;
export const FIND_CONTRATO = `${prefix}/getContrato`;
export const ACCT_CONTRATO = `${prefix}/acceptContrato`;
